<h3 mat-dialog-title>Bewerbung zurückstellen</h3>
<div mat-dialog-content style="overflow: visible">
  <div>
    <p>
      Hier kann die Bewerbung eines Start-ups zurückgestellt werden. Das bedeutet, dass die Produktseite wieder bearbeitet werden kann. Allerdings muss sich das
      Start-up danach erneut bewerben um für den Pitch berücksichtigt zu werden.
    </p>
    <p>
      Das Start-up wird eine E-Mail erhalten. Schreiben Sie hier ein Kommentar mit Begründung um dem Start-up eine Möglichkeit zu geben, ihre Bewerbung zu
      verbessern.
    </p>
  </div>
  <mat-form-field style="width: 95%; font-size: 1.25rem">
    <mat-label>Ihre Nachricht an das Start-up</mat-label>
    <textarea id="comment" name="comment" matInput cdkTextareaAutosize> </textarea>
  </mat-form-field>

  <div mat-dialog-actions>
    <markant-button class="blue button" (click)="cancel()">Abbrechen</markant-button>
    <div style="flex-grow: 1"></div>
    <markant-button class="pink primary button" (click)="send()">Absenden</markant-button>
  </div>
</div>
